module.exports = __webpack_public_path__ + "img/仪表盘@3x.b1aa8d94.png";